import Image from 'next/image';
import videoOverlayStyles from './video-overlay-icon.module.scss';

type VideoOverlayIconProps = {
  height?: number | string;
  width?: number | string;
};

export const VideoOverlayIconComponent = ({ height = 72, width = 72 }: VideoOverlayIconProps): React.JSX.Element | null => {
  const numericWidth = typeof width === 'number' ? width : 72;
  const numericHeight = typeof height === 'number' ? height : 72;

  const getSize = (value: number | string): string => {
    if (typeof value === 'number' || /^\d+$/.test(value)) return `${value}px`;

    if (/^\d+\/\d+$/.test(value)) {
      const [num, den] = value.split('/').map(Number);
      return `${(num / den * 100).toFixed(6).replace(/\.?0+$/, '')}%`;
    }

    return value;
  };

  const widthStyle = getSize(width);
  const heightStyle = getSize(height);

  return (
    <Image alt="Video Overlay"
      className={videoOverlayStyles['video-overlay-icon']}
      height={numericHeight}
      src="/img/videoOverlay.png"
      style={{ height: heightStyle, width: widthStyle }}
      width={numericWidth}
    />
  );
};
